import { WorkerRequirementMappingLevel } from "@clipboard-health/contract-worker-app-bff";
import { isDefined } from "@clipboard-health/util-ts";
import { type WorkerRequirement } from "@src/appV2/redesign/Documents/api/types";
import { intersection, isEmpty } from "lodash";

interface IsRequirementApplicableToShiftProps {
  requirement: WorkerRequirement;
  workplace: {
    id: string;
    workplaceType?: string;
    msa?: string;
    state?: string;
    region?: string;
  };
  qualifications: string[];
}

export function isRequirementApplicableToShift(
  props: IsRequirementApplicableToShiftProps
): boolean {
  const { requirement, workplace, qualifications } = props;
  const { id: workplaceId, workplaceType, msa, state, region } = workplace;

  return (
    requirement.requirementMappings?.some((mapping) => {
      const matchingWorkplaceTypes =
        isEmpty(mapping.attributes.workplaceTypes) ||
        (isDefined(workplaceType) && mapping.attributes.workplaceTypes.includes(workplaceType));

      const matchingQualifications = !isEmpty(
        intersection(mapping.attributes.qualifications, qualifications)
      );

      const matchingLevel =
        mapping.attributes.level === WorkerRequirementMappingLevel.GLOBAL ||
        (mapping.attributes.level === WorkerRequirementMappingLevel.HCF &&
          mapping.attributes.requiredBy.includes(workplaceId)) ||
        (isDefined(msa) &&
          mapping.attributes.level === WorkerRequirementMappingLevel.MSA &&
          mapping.attributes.requiredBy.includes(msa)) ||
        (isDefined(state) &&
          mapping.attributes.level === WorkerRequirementMappingLevel.STATE &&
          mapping.attributes.requiredBy.includes(state)) ||
        (isDefined(region) &&
          mapping.attributes.level === WorkerRequirementMappingLevel.COUNTY &&
          mapping.attributes.requiredBy.includes(region));

      return matchingWorkplaceTypes && matchingQualifications && matchingLevel;
    }) ?? false
  );
}
